import * as React from "react";
import SDK from "./sdk-re";

export const SDKREContext = React.createContext<{
  sdk: InstanceType<typeof SDK>;
}>({
  sdk: new SDK({ baseUrl: "" }),
});
